import { getStatistQueue } from './statist-queue';
var messagesHistoryLimit = 1000;
export var addMessageToHistory = function (message) {
    var statistQueue = getStatistQueue();
    if (!statistQueue.history) {
        statistQueue.history = [];
    }
    if (statistQueue.history.length >= messagesHistoryLimit) {
        return;
    }
    statistQueue.history.push(message);
};
export var getMessagesHistory = function () {
    var statistQueue = getStatistQueue();
    if (!statistQueue.history) {
        statistQueue.history = [];
    }
    return statistQueue.history;
};
//# sourceMappingURL=history.js.map